<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

    page: {
		title: 'Категории операций',
		meta: [{ name: 'description', content: appConfig.description }],
	},

    components: { Layout, PageHeader },

	data() {
		return {
			title: 'Категории операций',
			items: [],
            tableData: [],
            currentPage: 1,
            perPage: 50,
            pageOptions: [10, 25, 50, 100, 500],
            filter: null,
            filterOn: null,
            sortBy: 'id',
            sortDesc: false,
            fields: [
                { key: 'select', label: '', row:{'rowSelected':false}},
                { key: 'id',     label: 'ID', sortable: true },
                { key: 'name',   label: 'Название', sortable: true },
                { key: 'code',   label: 'Код', sortable: true },
                { key: 'status', label: 'Статус', sortable: true },
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },

    computed: {
        total_rows() {
            return this.$store.getters['financeTypes/GET_FINANCE_TYPES_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['financeTypes/GET_FINANCE_TYPES_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {
        await this.getData();
    },

    methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('financeTypes/FETCH_FINANCE_TYPES_LIST', data_send);
            this.watch = true;
        },
        async delItem(uuid){
            await this.$store.dispatch('financeTypes/FETCH_FINANCE_TYPES_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },        
    },
}
</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0">{{ title }}</h4>
            </div>
            <div class="col-sm-8 col-xl-6">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group">
                        <router-link to="/account/finance/types/create" class="btn btn-primary" right>
                            <i class="uil uil-plus mr-1"></i>Добавить категорию
                        </router-link>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                                <template #cell(action)="row">
                                    <b-dropdown
                                        variant="link"
                                        class="float-right"
                                        right
                                        toggle-class="p-0 text-muted arrow-none"
                                    >
                                        <template v-slot:button-content>
                                            <i class="uil uil-ellipsis-v font-size-14"></i>
                                        </template>
                                        <b-dropdown-item :to="{ name: 'Finance.Types.edit', params: { finance_type_uuid: row.item.uuid, copy: true }}"
                                            ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                        >
                                        <b-dropdown-item href="javascript: void(0);" @click.native="delItem(row.item.uuid)" variant="danger">
                                            <i class="uil uil-trash mr-2"></i>Удалить
                                        </b-dropdown-item>
                                    </b-dropdown>                                    
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>